<template>
  <v-container fluid class="role-management mt-4 px-1">
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการสิทธิ์ผู้ใช้</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + roles.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
<!--              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>-->
            </div>
          </v-card-title>

          <v-card-title class="pa-5 pb-0">
            <v-row align="center">

              <v-col class="d-flex" cols="12" sm="3">

                <v-select
                    @change="searchData"
                    v-model="search_data.role_master_full"
                    :items="role_master_combo"
                    item-text="role_title"
                    item-value="role_master_full"
                    label="รหัสหน้า"
                    clearable=""

                ></v-select>


              </v-col>



              <v-col class="d-flex" cols="12" sm="3">

                <v-select
                    @change="searchData"
                    v-model="search_data.user_name"
                    :items="role_users_combo"
                    item-text="full_name_th"
                    item-value="user_name"
                    label="บุคลากร"
                    clearable=""

                ></v-select>


              </v-col>



              <v-col class="d-flex" cols="12" sm="6">
                <v-text-field
                    append-icon="mdi-magnify"
                    class="search"
                    v-model="search"
                    label="ค้นหา (Search)"
                ></v-text-field>
              </v-col>




            </v-row>

          </v-card-title>



          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items-per-page="50"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="roles"
                :search="search"
                sort-by="order_seq">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.user_name="{ item }">
                <span>{{ item.fname_th }} {{ item.lname_th }} </span>

              </template>

              <template v-slot:item.role_page="{ item }">
                <span>{{ item.role_page }} <sup>{{ item.role_title }}</sup> </span>

              </template>


              <template v-slot:item.super_admin="{ item }">

                <span class="v-chip theme--light v-size--small " :class="item.super_admin=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.super_admin }}</span></span>


              </template>

              <template v-slot:item.view="{ item }">

                <span class="v-chip theme--light v-size--small " :class="item.view=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.view }}</span></span>


              </template>

              <template v-slot:item.add="{ item }">

                <span class="v-chip theme--light v-size--small " :class="item.add=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.add }}</span></span>


              </template>

              <template v-slot:item.edit="{ item }">

                <span class="v-chip theme--light v-size--small " :class="item.edit=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.edit }}</span></span>


              </template>

              <template v-slot:item.delete="{ item }">

                <span class="v-chip theme--light v-size--small " :class="item.delete=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.delete }}</span></span>


              </template>

              <template v-slot:item.own_only="{ item }">

                <span class="v-chip theme--light v-size--small "
                      :class="item.own_only=='Y' ? 'success' : 'warning'"><span
                    class="v-chip__content">{{ item.own_only }}</span></span>


              </template>


              <template v-slot:item.role_type="{ item }">
                <span>{{ displayText(item.role_type) }}</span>

              </template>

              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.role_master_full"
                      :rules="editForm.textReqRules"
                      :items="role_master_combo"
                      item-text="role_title"
                      item-value="role_master_full"
                      label="รหัสหน้า"
                      clearable=""
                      required
                  ></v-select>

                </v-col>


                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.role_master_full"
                      label="รหัสหน้า"
                      required
                      disabled
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.user_name"
                      :rules="editForm.textReqRules"
                      :items="role_users_combo"
                      item-text="full_name_th"
                      item-value="user_name"
                      label="ข้อมูลบุคลากร"
                      clearable=""
                      required
                  ></v-select>


                </v-col>


              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="9">
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.super_admin"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="แอดมิน"
                        required
                        @change="adminChange()"
                    ></v-switch>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.view"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="อ่าน"
                        required
                    ></v-switch>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.add"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="เพิ่ม"
                        required
                    ></v-switch>
                  </v-col>


                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.edit"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="แก้ไข"
                        required
                    ></v-switch>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.delete"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="ลบ"
                        required
                    ></v-switch>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="2">
                    <v-switch
                        v-model="editForm.own_only"
                        inset
                        color="success"
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="ผู้ใช้"
                        required
                    ></v-switch>
                  </v-col>

                </v-col>


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">
                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import axios from "axios";

export default {
  name: 'RoleManagement',
  data() {
    return {
      state: 'index',
      snackbar: null,
      search: '',
      search_data: {
        role_master_full: "",
        user_name:"",
      },
      selected: [],
      headers: [
        {
          text: 'บุคลากร',
          align: 'start',
          value: 'user_name',
        },

        {text: 'รหัสหน้า', value: 'role_page'},

        {text: 'แอดมิน', value: 'super_admin'},
        {text: 'อ่าน', value: 'view'},
        {text: 'เพิ่ม', value: 'add'},
        {text: 'แก้ไข', value: 'edit'},
        {text: 'ลบ', value: 'delete'},
        {text: 'ผู้ใช้', value: 'own_only'},

        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ['role_group','order_seq','user_name'],
        sortDesc: [false,false,false]
      },

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        role_id: '',
        codeRules: validateRules.codeRules,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        role_master_full: '',
        user_name: '',
        active: 'N',
        super_admin: 'N',
        view: 'N',
        add: 'N',
        edit: 'N',
        delete: 'N',
        own_only: 'N',
      },
      role_master_combo: [],
      role_users_combo: [],
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('roles', ['roles', "isReceiving", "isDeleting", "idToDelete", "roleMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    roleMessage() {

      if (this.roleMessage !== '') {
        this.notification = this.roleMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getRolesRequest(this.search_data);
    this.getDcParamCombobox();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('roles',
        [
          "getRolesRequest",
          "deleteRoleRequest",
          "updateRoleRequest",
          "createRoleRequest"
        ]
    ),
    async getDcParamCombobox() {

      try {

        await axios.post(config.baseURLApi + '/combo/' + 'dcRoleMasterActive', '', {
          headers: {},
        }).then(res => {
          this.role_master_combo = res.data;
        });

        const formData = new FormData();
        formData.append('role_group', 'member');
        formData.append('role_page', '/member/role');
        formData.append('check_role', '');

        await axios.post(config.baseURLApi + '/combo/' + 'usersActiveOwn', formData, {
          headers: {},
        }).then(res => {
          this.role_users_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }


    },

    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.editForm.role_id = null;
      this.editForm.active = 'Y';
      this.editForm.role_master_full = '';
      this.editForm.user_name = '';
      this.editForm.active = 'N';
      this.editForm.super_admin = 'N';
      this.editForm.view = 'N';
      this.editForm.add = 'N';
      this.editForm.edit = 'N';
      this.editForm.delete = 'N';
      this.editForm.own_only = 'N';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.roles.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.role_id = item.role_id;
      this.editForm.role_group = item.role_group;
      this.editForm.role_master_full = item.role_group+'#'+item.role_page;
      this.editForm.user_name = item.user_name;
      this.editForm.role_page = item.role_page;
      this.editForm.super_admin = item.super_admin;
      this.editForm.view = item.view;
      this.editForm.add = item.add;
      this.editForm.edit = item.edit;
      this.editForm.delete = item.delete;
      this.editForm.own_only = item.own_only;
      this.editForm.remark = item.remark;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteRoleRequest({role_id: item.role_id})


    },
    close() {

      if (this.errorMessage == false || this.roleMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      var myArray = this.editForm.role_master_full.split("#");
      this.editForm.role_group = myArray[0];
      this.editForm.role_page = myArray[1];

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.roles[this.editedIndex], this.editForm)
            :
            this.updateRoleRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.roles.push(this.editForm)
            :
            this.createRoleRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    adminChange() {

      var set = 'N';
      if (this.editForm.super_admin == 'Y') {
        set = 'Y'
      }
      this.editForm.view = set;
      this.editForm.add = set;
      this.editForm.edit = set;
      this.editForm.delete = set;
      this.editForm.own_only = set;
    },
    searchData() {
      this.getRolesRequest(this.search_data);
    },


  },
}
</script>

<style src="./RoleManagement.scss" lang="scss"/>
